import { render } from "./MyComponent.vue?vue&type=template&id=4a19fab7&scoped=true&ts=true"
import script from "./MyComponent.vue?vue&type=script&lang=ts"
export * from "./MyComponent.vue?vue&type=script&lang=ts"

import "./MyComponent.vue?vue&type=style&index=0&id=4a19fab7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a19fab7"]])

export default __exports__